import React from 'react'
import IconBase from './IconBase'

const Email = props =>
  <IconBase viewBox="-524 -1094.5 80 53.5" {...props}>
    <path id="Path_84" data-name="Path 84" d="M40.1,98.816h.017a3.077,3.077,0,0,0,1.682-.494l.131-.084c.028-.019.058-.035.088-.055l1.524-1.261L79.916,66.905a.427.427,0,0,0-.34-.175H.423a.411.411,0,0,0-.262.1L38.216,98.192A2.981,2.981,0,0,0,40.1,98.816ZM0,70.984v44.493L27.261,93.454ZM52.767,93.6,80,115.488V71.132Zm-8.658,7.143a6.487,6.487,0,0,1-8,.007L29.87,95.6,0,119.73v.077a.432.432,0,0,0,.428.424H79.577A.431.431,0,0,0,80,119.8v-.071L50.156,95.755Z" transform="translate(-524 -1161.231)"/>
  </IconBase>

export default Email
